const frameRateMilli = Number(1000 / 60) // eslint-disable-line no-magic-numbers

export function easeInOutQuad(time: number, start: number, change: number, duration: number) {
  let timeDMilli = time
  timeDMilli /= duration / 2
  if(timeDMilli < 1) {
    return change / 2 * timeDMilli * timeDMilli + start
  }
  timeDMilli--
  return -change / 2 * (timeDMilli * (timeDMilli - 2) - 1) + start
}

/* TODO: AVWebStorefront-718 - Integration Tests */
interface HTMLElementIndexed extends HTMLElement {
    [key: string]: any
}

interface WindowPolyfill extends Window {
    requestAnimationFrame: (cb: FrameRequestCallback) => any
}

export function scrollTo(element: HTMLElementIndexed, to: number, duration: number,
  direction: string = 'scrollLeft') {
  (window as WindowPolyfill).requestAnimationFrame = window.requestAnimationFrame ||
    function timeFn(cb) {
      window.setTimeout(cb, frameRateMilli)
    }

  const start = element[direction]
  const change = to - start
  const frameRate = frameRateMilli
  const framesLength = Math.ceil(duration / frameRate)
  const frames = Array(framesLength).fill(0).map((_, index) =>
    easeInOutQuad(frameRate * index, start, change, duration))
  let currentTimeMilli = 0

  const animateScroll = () => {
    currentTimeMilli += frameRate
    /* istanbul ignore next */
    if(currentTimeMilli < duration) {
      element[direction] = frames.shift()
      requestAnimationFrame(animateScroll)
    }
  }
  animateScroll()
}